// =============================================================================
// FEATURE FLAGS — Features PENDIENTES (futuras), ocultas del UI a propósito.
// =============================================================================
// IMPORTANTE: estas features están OCULTAS (sin acceso desde el menú ni desde
// los puntos acoplados), pero su código —rutas, páginas, componentes, servicios,
// esquemas y tablas de BD— se MANTIENE INTACTO. NO es código muerto: son
// implementaciones futuras a medio terminar que retomaremos.
//
// ⛔ NO eliminar `crops`, `imageAnalysis`, `cameras`, `devices/Devices.tsx`,
//    `features/crops/*`, `features/imageAnalysis/*`, ni sus rutas/servicios en
//    limpiezas de "código muerto". Para REACTIVAR una feature, pon su flag en
//    `true` (y revisa los puntos que la consumen: Sidebar + StationForm +
//    StationsSection + StationCard).
//
// De momento el foco del producto es el MONITOREO (estaciones, sensores,
// lecturas, alertas, actuadores).
// =============================================================================
export const FEATURES = {
  /** Cultivos (agrupación agronómica + ancla de cámaras/análisis de imágenes). */
  crops: false,
  /** Análisis de Imágenes con IA (profundidad/salud del cultivo). */
  imageAnalysis: false,
  /** Cámaras RTSP/WebRTC (se gestionan desde un cultivo). */
  cameras: false,
} as const;
